/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Password_Too_LongInputs */

const fr_error_password_too_long = /** @type {(inputs: Error_Password_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez 200 caractères maximum.`)
};

const en_error_password_too_long = /** @type {(inputs: Error_Password_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use no more than 200 characters.`)
};

/**
* | output |
* | --- |
* | "Use no more than 200 characters." |
*
* @param {Error_Password_Too_LongInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_password_too_long = /** @type {((inputs?: Error_Password_Too_LongInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Password_Too_LongInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_password_too_long(inputs)
	return fr_error_password_too_long(inputs)
});